$(function () {
  let section = $('#seccionSuscripciones')
  if (section.get(0) == null) {
    return
  }
  let vueApp = new Vue({
    el: section.get(0),
    data: {
      loader: false,
      filtros: { page: 1, buscar: null, producto_id: null, cliente_id: null,
      estatus: null},
      suscripciones: [],
      modalTitulo: "Editar suscripción",
      suscripcion: {}
    },
    mounted() {
      this.getSuscripciones()
    },
    methods: {
      getEncodedParams(){
        let params = Object.assign({}, this.filtros)
        delete params.page
        delete params.from
        delete params.to
        delete params.per_page
        delete params.total
        if(params.buscar == null || params.buscar.length == 0){
          delete params.buscar
        }
        if(params.estatus == null || params.estatus.length == 0){
          delete params.estatus
        }
        if(params.producto_id == null || params.producto_id.length == 0){
          delete params.producto_id
        }
        if(params.cliente_id == null || params.cliente_id.length == 0){
          delete params.cliente_id
        }
        return new URLSearchParams(params).toString();
      },
      getSuscripciones(pagina = null) {
        if (this.loader) {
          return
        }
        if (pagina != null) {
          this.filtros.page = pagina
        }
        this.loader = true
        axios
          .get('/admin/clientes/suscripciones/json', {
            params: this.filtros,
          })
          .then((response) => {
            vueApp.loader = false
            if (response.data.error) {
              swal(response.data.error, "", "info")
              return
            }
            vueApp.suscripciones = response.data.suscripciones.data;
            vueApp.filtros.total = response.data.suscripciones.total;
            vueApp.filtros.per_page = response.data.suscripciones.per_page;
            vueApp.filtros.from = response.data.suscripciones.from;
            vueApp.filtros.to = response.data.suscripciones.to;
          })
          .catch((error) => {
            vueApp.loader = false
            swal("Ocurrió un error inesperado", "", "info")
          })
      },
      cancelarRenovacion(suscripcion) {
        swalQ("¿Cancelar renovación de "+suscripcion.producto.nombre+"?", "", "warning").then((ok) => {
          if (ok) {
            axios
              .delete('/admin/clientes/suscripciones/cancelar/' + suscripcion.id)
              .then(function (response) {
                if (response.data.error) {
                  swal(response.data.error, "", "info")
                  return
                }
                vueApp.getSuscripciones(1)
              })
              .catch((error) => {
                console.log(error)
                swal("Ocurrió un error inesperado", "", "info")
              })
          }
        })
      },
      editar(suscripcion) {
        this.suscripcion = Object.assign({}, suscripcion)
        this.modalTitulo = 'Editar suscripción'
        $('#modalSuscripcion').modal('show')
        this.validar()
      },
      validar() {
        this.$nextTick(() => {
          $('#formSuscripcion').validarForm((form) => {
            vueApp.guardar(form)
          })
        })
      },
      guardar(form) {
        $('#btnGuardar').loader('show')
        let formData = new FormData(form)
        axios
          .post('/admin/clientes/suscripciones/guardar', formData)
          .then((respuesta) => {
            $('#btnGuardar').loader('hide')
            if (respuesta.data.error) {
              swal(respuesta.data.error, "", "info")
              return
            }
            swal("Registro guardado correctamente", "", "success")
            $('#modalSuscripcion').modal('hide')
            vueApp.getSuscripciones(1)
          })
          .catch((error) => {
            console.log(error)
            $('#btnGuardar').loader('hide')
            swal("Ocurrió un error inesperado", "", "info")
          })
      },
    },
  })
})
